
/* injects from baggage-loader */

'use strict';

import { stoneList } from './montanha.const';

import _ from "lodash";

export default class MontanhaController {
	constructor($log, $state, $timeout, Session, Dialog){
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$timeout = $timeout;
		this.Session = Session;
		this.Dialog = Dialog;

		this.stoneList = stoneList;
		this.showHelpTab = false;

		this.altarStones = [
		{ bg: null , nome: 'green', visible: false },
		{ bg: this.stoneList[1] , nome: 'blue', visible: true },
		{ bg: this.stoneList[2] , nome: 'yellow', visible: true },
		{ bg: null , nome: 'red', visible: false }
		];

		this.boxStones = [
		{ nome: 'green', visible: true, src:this.stoneList[0] },
		{ nome: 'red', visible: true, src:this.stoneList[3] }
		];
	}

	$onInit(){
		this.Dialog.showTutorial('m5');
	}

	dropStone(index, data){	
		if(this.altarStones[index].nome === data.data.nome){
			this.altarStones[index].bg = data.data.src;
			this.altarStones[index].visible = true;
			let indexBox = _.findIndex(this.boxStones, ['nome', data.data.nome]);
			this.boxStones[indexBox].visible = false;
		}
		if(_.every(this.altarStones, 'visible')){
			this.Session.setEndGame(true);
			this.$state.go("main");
			// this.$log.log(this.altarStones);
		}
	}

	showHelp(){
		this.showHelpTab = !this.showHelpTab;
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/montanha/montanha.controller.js